import { API } from 'aws-amplify';
import { DeviceEvent } from '../model/device-events/device-event';
import { PaginatedDeviceEventFilter } from '../model/device-events/device-event-filters';

export const getEventsPaginated = async (query: PaginatedDeviceEventFilter): Promise<DeviceEvent[]> =>
  API.post('events', '/events-paginated', {
    body: query,
  });
